import { gql } from "graphql-tag"

const tmdb = gql`
  enum SearchType {
    MOVIE
    TV
    BOTH
  }

  type TMDBSearchResult {
    id: ID!
    title: String!
    year: String!
    mediaType: String
    poster: String
    overview: String
    externalIds: TMDBExternalIDs
  }

  type TMDBExternalIDs {
    imdbId: String
    tvdbId: Int
    wikidataId: String
  }
`

export default tmdb
